import MainPageHeaderMobile from "common/components/MainPageHeader/MainPageHeaderMobile";
import HeaderStudentFolder from "features/studentFolder/components/HeaderStudentFolder";
import StudentFolderTabs from "features/studentFolder/components/StudentFolderTabs";
import React from "react";

interface Props {
  data: any;
  activeLesson: number;
  onClickExercise?: (item: any, typeClick?: "exercise" | "course") => void;
  onSelect?: (k?: string) => void;
  onSearch?: (text: string) => void;
  onCheck?: (val: any) => void;
  onChangeLesson?: (val: number) => void;
  searchData?: any[];
  search?: string;
}

const StudentFolderMobile = ({
  data,
  onSelect,
  activeLesson,
  onClickExercise,
  onSearch,
  onCheck,
  onChangeLesson,
  searchData,
  search
}: Props) => {
  return (
    <div className="student-folder-wrapper-mobile">
      <MainPageHeaderMobile title="תיק תלמיד" />
      <HeaderStudentFolder onSearch={onSearch} onCheck={onCheck} onChangeLesson={onChangeLesson} />
      <StudentFolderTabs
        onSelect={onSelect}
        data={data}
        search={search}
        searchData={searchData}
        activeLesson={activeLesson}
        onClickExercise={onClickExercise}
      />
    </div>
  );
};

export default StudentFolderMobile;
